module.exports = __webpack_public_path__ + "static/media/ss.aeb0bfe5.jpg";